import React from 'react';
import { GameState } from '../../game';
import { formatMoney } from '../../game/presentation';

interface GameOverScreenProps {
  game: GameState;
  onPlayAgain: () => void;
  onHome: () => void;
  playingAgain?: boolean;
}

const BURST_COUNT = 20;

const GameOverScreen: React.FC<GameOverScreenProps> = ({ game, onPlayAgain, onHome, playingAgain }) => {
  const ranked = [...game.players].sort((a, b) => b.totalScore - a.totalScore);
  const winnerIds = new Set(game.winners.map((winner) => winner.id));
  const headline =
    game.winners.length === 1
      ? `${game.winners[0].name} wins`
      : `Tie at ${formatMoney(game.winners[0]?.totalScore ?? 0)}`;

  return (
    <div className="ss-overlay is-center ss-cele-overlay is-win" role="dialog" aria-modal="true" aria-labelledby="over-title">
      <div className="ss-burst is-win" aria-hidden="true">
        {Array.from({ length: BURST_COUNT }, (_, index) => (
          <span key={index} className="ss-burst-bit" style={{ '--i': index } as React.CSSProperties} />
        ))}
      </div>
      <div className="ss-modal ss-cele is-win">
        <p className="ss-kicker">Game over</p>
        <div className="big" id="over-title">
          {headline}
        </div>
        <p className="ss-sub">{game.message}</p>
        <ol className="ss-final-list">
          {ranked.map((player) => (
            <li key={player.id} className={winnerIds.has(player.id) ? 'winner' : undefined}>
              <span>{player.name}</span>
              <span>{formatMoney(player.totalScore)}</span>
            </li>
          ))}
        </ol>
        <div className="ss-row">
          <button type="button" className="ss-btn ss-btn-primary" onClick={onPlayAgain} disabled={playingAgain}>
            {playingAgain ? 'Starting…' : 'Play again'}
          </button>
          <button type="button" className="ss-btn ss-btn-ghost" onClick={onHome}>
            Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameOverScreen;
